export default __webpack_public_path__ + "static/media/hht2_direction_quiztime_02.97f27d0f.png";